'use strict';

angular.module('sellers')
.filter('messages', ['$log', function($log) {

  // Filter messages (Inbox vs Sent)
  return function(messages, tgl) {
    var output =[];

    if(messages.length > 0) {
      angular.forEach(messages, function(msg) {
        if(msg.toRef.seller == 0 && tgl == 'inbox') {
            output.push(msg);
        } else if (msg.toRef.seller !== 0 && tgl == 'sent') {
            output.push(msg);
        }
      });
    }

    return output;
  }

}]);